import React, { useEffect, useState } from "react";
import {
  Label,
  TabContent,
  NavLink,
  NavItem,
  Nav,
  FormGroup,
} from "reactstrap";
import {
  errorHandler,
  formatDateForSearchConsole,
} from "../../../helper-methods";
import ConsoleLineGraph from "../components/graph/googleConsoleGraph";
import CustomTable from "../components/CustomTable";
import { getGoogleSearchConsoleStat } from "../../../http/http-calls";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";

const dataHeaderKeys = [
  { id: "id", label: "id" },
  { id: "query", label: "Query", noSort: true },
  { id: "clicks", label: "Clicks", noSort: true },
  { id: "impressions", label: "Impressions", noSort: true },
  { id: "ctr", label: "CTR", noSort: true },
  { id: "position", label: "Position", noSort: true },
];

const GoogleSearchConsole = () => {
  const [activeTab, setActiveTab] = useState("query");
  const [dataHeaderKey, setDataHeaderKey] = useState(dataHeaderKeys);
  const [dateRangeValue, setDateRangeValue] = useState([
    new Date().setMonth(new Date().getMonth() - 3),
    new Date().setDate(new Date().getDate() - 1),
  ]);

  const [loading, setLoading] = useState({
    showTableLoading: false,
    showStatusLoading: false,
  });
  const [tableConfig, setTableConfig] = useState({
    skip: 0,
    limit: 10,
    pageNumber: 1,
  });
  const [statsList, setStatsList] = useState({
    data: [],
    totalCount: 0,
  });

  const [graphData, setGraphData] = useState([]);

  const [statsListBackup, setStatsListBackup] = useState([]);

  const _toggleTab = (tab) => {
    if (tab) {
      setActiveTab(tab);
      const updatedDataHeaderKeys = dataHeaderKey.map((item) =>
        item.id === "query" ? { ...item, label: tab } : item
      );
      setDataHeaderKey(updatedDataHeaderKeys);
      _getGoogleSearchConsoleStat({ tab });
    }
  };

  const _manageLoading = (loaderName, value) => {
    const newLoading = { ...loading };
    newLoading[loaderName] = value;

    setLoading(newLoading);
  };

  // const toggle = () => setModal(!modal);

  const _getGoogleSearchConsoleStat = async (payload) => {
    console.log("payload: ", payload);

    try {
      _manageLoading("showTableLoading", true);
      const apiPayload = {
        filters: {},
      };

      apiPayload.filters["dimensions"] = [payload.tab];
      // apiPayload.filters["startDate"] = formatDateForSearchConsole(new Date());
      apiPayload.filters["startDate"] = formatDateForSearchConsole(
        dateRangeValue[0]
        // new Date().setMonth(new Date().getMonth() - 3)
      );
      apiPayload.filters["endDate"] = formatDateForSearchConsole(
        // new Date().setDate(new Date().getDate() - 1)
        dateRangeValue[1]
      );

      console.log("apiPayload: ", apiPayload);
      const res = await getGoogleSearchConsoleStat(apiPayload);

      setStatsList({
        data: res?.stats ? res?.stats.slice(0, 11) : [],
        // data: stats,
        totalCount: res.totalCount ? res.totalCount : res.stats.length,
      });
      setStatsListBackup(res.stats);
      _setCardInfo(res.stats);
      setGraphData(res?.graph || []);

      _manageLoading("showTableLoading", false);
    } catch (err) {
      errorHandler(err);
      _manageLoading("showTableLoading", false);
    }
  };

  const _setCardInfo = (data) => {
    let totalClicks = 0;
    let totalImpressions = 0;
    let totalCtr = 0;
    let totalPosition = 0;
    let numberOfEntries = data.length;

    data.forEach((entry) => {
      totalClicks += entry.clicks;
      totalImpressions += entry.impressions;
      totalCtr += entry.ctr;
      totalPosition += entry.position;
    });

    let averageCtr = (totalCtr / numberOfEntries) * 100;
    let averagePosition = (totalPosition / numberOfEntries).toFixed(2);
  };

  const _dataFormat = (cell, row, header) => {
    // console.log("1234", header)

    switch (header) {
      case "query": {
        return row?.keys ? row?.keys[0] : "N/A";
      }
      case "clicks": {
        return row?.clicks ? row?.clicks : "N/A";
      }

      // case "query": {
      //   return row?.type ? row?.type : "N/A";
      // }

      case "impressions": {
        return row?.impressions ? row?.impressions : "N/A";
      }

      case "ctr": {
        return row?.ctr ? (row?.ctr * 100).toFixed(2) : "N/A";
      }

      case "position": {
        return row?.position ? (row?.position).toFixed(1) : "N/A";
      }

      default: {
        return cell;
      }
    }
  };

  const filterSearchParameter = (
    graphkey = ["clicks", "impressions", "ctr", "position"]
  ) => {
    console.log("graphkey", graphkey);
    // console.log("stats", stats);
    const updatedStats =
      statsListBackup?.length > 0 &&
      statsListBackup?.map((obj) => {
        // Create a new object with only the keys that need to be retained
        const newObj = {};
        Object.keys(obj).forEach((key) => {
          if (key === "keys" || key === "clicks" || graphkey.includes(key)) {
            newObj[key] = obj[key];
          }
        });
        return newObj;
      });

    console.log(updatedStats);

    const filteredDataHeaderKeys = dataHeaderKeys.filter(
      (item) =>
        item.id === "id" || item.id === "query" || graphkey.includes(item.id)
    );

    // console.log(filteredDataHeaderKeys);
    setDataHeaderKey(filteredDataHeaderKeys);

    setStatsList({
      ...statsList,
      // data: res.stats,
      data: updatedStats,
    });
    _paginate();
  };

  const _onChangeDatePicker = (dateRangeValue) => {
    setDateRangeValue(dateRangeValue);
  };

  const _paginate = (pageNumber = 1, pageSize = 10) => {
    console.log("pageNumber, pageSize :", pageNumber, pageSize);

    const newTableConfig = { ...tableConfig };

    newTableConfig.pageNumber = pageNumber;
    newTableConfig.skip = (pageNumber - 1) * pageSize;
    newTableConfig.limit = pageSize;

    let newStatsList = statsListBackup?.slice(
      (pageNumber - 1) * pageSize,
      newTableConfig.skip + pageSize
    );
    console.log("new", newStatsList);
    setStatsList({
      ...statsList,
      // data: res.stats,
      data: newStatsList,
    });
    setTableConfig(newTableConfig);
  };

  useEffect(() => {
    _toggleTab(activeTab);
    filterSearchParameter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRangeValue]);

  return (
    <>
      <div className="content">
        <div className="responsiveTitle">
          <h2>Google Search Console</h2>
        </div>
        <div className="filterWrapper mb-3">
          <FormGroup className="dateRange">
            <Label>Date Range</Label>
            <DateRangePicker
              // clearIcon={null}
              className="dateRange"
              format="MM-dd-y"
              dayPlaceholder="dd"
              monthPlaceholder="mm"
              yearPlaceholder="yyyy"
              onChange={(dateRangeValue) => _onChangeDatePicker(dateRangeValue)}
              value={dateRangeValue}
            />
          </FormGroup>
        </div>

        <ConsoleLineGraph
          data={graphData}
          onClickCard={(values) => filterSearchParameter(values)}
        />

        <div className="mt-3">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === "query" ? "active" : ""}
                onClick={() => _toggleTab("query")}
              >
                Queries
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab === "page" ? "active" : ""}
                onClick={() => _toggleTab("page")}
              >
                Page
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab === "country" ? "active" : ""}
                onClick={() => _toggleTab("country")}
              >
                Countries
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={activeTab === "date" ? "active" : ""}
                onClick={() => _toggleTab("date")}
              >
                Dates
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {dataHeaderKey && dataHeaderKey?.length && (
              <CustomTable
                isPagination={true}
                isPageStartFromOne={true}
                pageNumber={tableConfig.pageNumber}
                pageSize={tableConfig?.limit}
                tableData={statsList.data}
                headerKeys={dataHeaderKey}
                dataFormat={_dataFormat}
                totalCount={statsList.totalCount}
                rowSelection={false}
                onPaginate={(pageNumber, pageSize) =>
                  _paginate(pageNumber, pageSize)
                }
                onSortChange={(sortName, sortOrder) =>
                  // sort is disabled
                  _paginate()
                }
                showTableLoading={loading.showTableLoading}
                // hidePagination={true} // to hide table pagination
              />
            )}
          </TabContent>
        </div>
      </div>
    </>
  );
};

export default GoogleSearchConsole;
